import "../styles/EducationCard.css";
import { useEffect, useState } from "react";

type EducationProps = {
  id: number;
  eduSize: string;
  eduUniversity: string;
  eduDegree: string;
  eduDates: string;
  eduLink: string;
  eduStudies: string[];
  position: "left" | "right";
};

function EducationCard(props: EducationProps) {
  const [flipped, setFlipped] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1279);

  const handleResize = () => {
    if (window.innerWidth > 1279) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // Clean up event listener
  }, []);

  const isMajor = props.eduSize === "Major";
  const cardSize = isMajor ? 700 : 600;
  const cardMarginRight = isMajor ? 0 : 100;
  const cardMarginTop = isMajor ? 0 : -350;

  const cardStyle = {
    width: cardSize,
    height: cardSize,
    marginTop: cardMarginTop,
    marginRight: cardMarginRight,
  };

  const introStyle = {
    paddingTop: cardSize * 0.1,
    width: cardSize * 0.7,
    height: cardSize * 0.7,
  };

  const studiesSectionStyle = {
    width: cardSize * 0.5,
  };

  const frontBackStyle = {
    backgroundColor: isMajor ? "#00d4fa" : "#003459",
    color: isMajor ? "black" : "white",
  };

  if (isDesktop) {
    return (
      <div
        className={`eduCard-container ${flipped ? "flipped" : ""} ${
          props.position
        }`}
        onClick={() => setFlipped(!flipped)}
        style={cardStyle}
      >
        <div className="eduCard">
          {/* Front */}
          <div className="eduCard-front" style={frontBackStyle}>
            <div className="eduIntro" style={introStyle}>
              <div className="eduSize">{props.eduSize}</div>
              <div className="eduUniversity">{props.eduUniversity}</div>
              <div className="eduDegree">{props.eduDegree}</div>
              <div className="eduDates">{props.eduDates}</div>
            </div>
          </div>

          {/* Back */}
          <div className="eduCard-back" style={frontBackStyle}>
            <div className="eduStudiesSection" style={studiesSectionStyle}>
              <div className="eduStudiesTitle">Studies</div>
              <ul>
                {props.eduStudies.map((study, index) => (
                  <li className="eduStudies" key={index}>
                    {study}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="eduCardContainer" onClick={() => setFlipped(!flipped)}>
        <div
          className={`eduCard ${flipped ? "flipped" : ""}`}
          style={frontBackStyle}
        >
          <div className="eduIntro">
            <div className="eduSize">{props.eduSize}</div>
            <div className="eduUniversity">{props.eduUniversity}</div>
            <div className="eduDegree">{props.eduDegree}</div>
            <div className="eduDates">{props.eduDates}</div>
          </div>
        </div>
        <div className={`eduStudiesSection ${flipped ? "flipped" : ""}`}>
          <div className="eduStudiesTitle">Studies</div>
          <ul className="eduStudiesList">
            {props.eduStudies.map((study, index) => (
              <li className="eduStudies" key={index}>
                {study}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default EducationCard;
